import { Text } from "@redotech/redo-web/text";
import { memo, ReactNode } from "react";

export interface FieldLabelProps {
  children: ReactNode;
}

export const FieldLabel = memo(function FieldLabel({
  children,
}: FieldLabelProps) {
  return (
    <Text fontSize="xs" textColor="quaternary" whiteSpace="nowrap">
      {children}
    </Text>
  );
});
